import { useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

const showUnderLine = (activeLink, links) => {
  const actualLink = activeLink?.split('/').reverse() || []
  const plainLinks = links.reduce((acc, actual) => {
    if (actual?.to || actual.to === '') {
      return [...acc, actual.to]
    }
    return [...acc, actual]
  }, [])
  return plainLinks?.find(
    (item) => item?.split('/').reverse()[0] === actualLink[0],
  )
}
const useMenuLink = ({ parentLink, links }) => {
  const [isOpen, setIsOpen] = useState(false)
  const timeOut = useRef()
  const location = useLocation()
  const underLineIsShowed = useMemo(
    () => showUnderLine(location.pathname, [parentLink.to, ...links]),
    [links, location.pathname, parentLink.to],
  )
  const closeMenu = () => {
    setIsOpen(false)
  }
  const retardedClose = () => {
    timeOut.current = setTimeout(() => {
      closeMenu()
    }, 100)
  }
  const openMenu = () => {
    clearTimeout(timeOut.current)
    setIsOpen(true)
  }
  return {
    isOpen,
    underLineIsShowed,
    closeMenu,
    retardedClose,
    openMenu,
  }
}

export default useMenuLink
